import { render } from "./Footer.vue?vue&type=template&id=98d91c74&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "@/assets/css/Footer.scss?vue&type=style&index=0&id=98d91c74&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d91c74"]])

export default __exports__